module.exports = __webpack_public_path__ + "img/thumbnail_Dhole_j_normal.a46c2739.png";